/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import progressBarStyle from "./progressBarStyle";
import Line from "rc-progress/lib/Line";
import Grid from "@mui/material/Grid";
import Hidden from "@mui/material/Hidden";
import _map from "lodash/map";
import { Box } from "@mui/material";

type ProgressBarStep = {
  key: string;
  name: string;
  icon: string;
};

type ProgressBarProps = {
  steps: Array<ProgressBarStep>;
  active: string;
  progress: number;
};

const ProgressBar = ({ steps, active, progress, ...rest }: ProgressBarProps) => {
  const stepWidth = Math.floor(100 / steps.length) + "%";

  return (
    <Grid sx={progressBarStyle.progressBarContainer} container {...rest}>
      <Grid item xs={12}>
        <Line percent={progress} strokeWidth={3} trailWidth={3} strokeColor="#137f7b" strokeLinecap="square" style={progressBarStyle.line} />
      </Grid>
      <Grid item xs={12} sx={progressBarStyle.shifted}>
        <Grid container>
          {_map(steps, (step, key) => {
            return (
              <Grid key={key} item sx={{ ...progressBarStyle.iconContainer, maxWidth: stepWidth, flexBasis: stepWidth }} >
                <Box component={"img"} sx={progressBarStyle.icon} src={step.icon} alt={step.name} />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Hidden smDown>
        <Grid item xs={12}>
          <Grid container>
            {_map(steps, (step, key) => {
              return (
                <Grid key={key} item sx={{ ...progressBarStyle.label, maxWidth: stepWidth, flexBasis: stepWidth }}>
                  <Box component={"span"} sx={active === step.key ? progressBarStyle.active : progressBarStyle.inactive}>
                    <strong>{step.name}</strong>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Hidden>
    </Grid>
  );
};

export default ProgressBar;
